<div *ngIf="createMode" class="grid grid-cols-[1fr_2fr] !h-[20px]">
  <ng-select placeholder="--" [clearable]="false" [items]="hourValues" [(ngModel)]="hour" (ngModelChange)="onValueChange()" class="w-full [&>_.ng-select-container]:!h-full"> </ng-select>
  <div class="grid grid-cols-[1fr_1fr] border-grey-300 border-solid border ml-2 rounded">
    <div *ngFor="let period of ['AM', 'PM']" class="text-grey-400 bg-white font-primary px-3 py-4 cursor-pointer" [ngClass]="{ '!bg-primary-1-500 !text-white': amOrPm === period, '!bg-grey-100 !cursor-not-allowed !pointer-events-none': disabled }" (click)="toggleAmPm()">
      <span class="text-xs cursor-pointer">{{ period }}</span>
    </div>
  </div>
</div>
